<template>
  <v-row v-if="documents.length > 0" v-resize="checkMobile">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <v-row>
      <v-col
        cols="12"
      >
        <v-list class="my-2">
          <!-- <v-subheader>{{ $t('custom.files') }}</v-subheader> -->
          <draggable
            :value="documents"
            @end="moveDocument"
            class="row"
            v-if="!isMobile"
          >
            <v-list-item
              v-for="item in documents"
              :key="item.id"
            >
              <v-list-item-avatar tile>
                <media-thumb
                  v-if="item.document_type && item.document_type.includes('image')"
                  compact
                  :alt="item.original_name ? item.original_name : `${item.id}`"
                  :src="item.url"
                  :content-type="item.document_type"
                  :name="item.original_name"
                  style="cursor: pointer;"
                  @click="screenFullImage(item)"
                />
                <v-icon
                  v-else
                  color="grey"
                  @click="screenFullImage(item)"
                >
                  mdi-file
                </v-icon>
              </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title 
                v-if="edit_filename_id != item.id" 
                @click="edit_filename_id = item.id" 
                style="cursor: pointer;"
              >
                {{ truncateFileName(item.original_name ? item.original_name : item.id, isMobile ? 20 : 40) }}
              </v-list-item-title>
              <v-text-field
                v-else
                v-model="item.original_name"
                @keyup.enter="updateFileInfo(item)"
                @blur="updateFileInfo(item)"
                :loading="isLoadingUpdateFileInfo"
                autofocus
              ></v-text-field>
            </v-list-item-content>

            <v-list-item-icon>
              <v-icon color="success" @click="downloadItem(item)" class="mx-1">
                mdi-content-save-outline
              </v-icon>
              <v-icon color="error" @click="deleteItem(item)" class="mx-1">
                mdi-delete-forever
              </v-icon>
            </v-list-item-icon>
            </v-list-item>
          </draggable>
          <v-list-item
            v-else
            v-for="item in documents"
            :key="item.id"
          >
            <v-list-item-avatar tile>
              <media-thumb
                v-if="item.document_type && item.document_type.includes('image')"
                compact
                :alt="item.original_name ? item.original_name : `${item.id}`"
                :src="item.url"
                :content-type="item.document_type"
                :name="item.original_name"
                style="cursor: pointer;"
                @click="screenFullImage(item)"
              />
              <v-icon
                v-else
                color="grey"
                @click="screenFullImage(item)"
              >
                mdi-file
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title 
                v-if="edit_filename_id != item.id" 
                @click="edit_filename_id = item.id" 
                style="cursor: pointer;"
              >
                {{ truncateFileName(item.original_name ? item.original_name : item.id, isMobile ? 20 : 40) }}
              </v-list-item-title>
              <v-text-field
                v-else
                v-model="item.original_name"
                @keyup.enter="updateFileInfo(item)"
                @blur="updateFileInfo(item)"
                :loading="isLoadingUpdateFileInfo"
                autofocus
              ></v-text-field>
            </v-list-item-content>

            <v-list-item-icon>
              <v-icon color="success" @click="downloadItem(item)" class="mx-1">
                mdi-content-save-outline
              </v-icon>
              <v-icon color="error" @click="deleteItem(item)" class="mx-1">
                mdi-delete-forever
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" :retain-focus="false" persistent max-width="1200">
      <v-card class="mt-2">
        <v-card-title> </v-card-title>
        <v-card-text>
          <media-thumb :src="link_full_image" :aspect-ratio="null" :download-href="link_full_image" />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="(dialog = false), (link_full_image = '')"
          >
            {{ $t('custom.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import MediaThumb from "@/components/MediaThumb.vue";
import { saveAs } from "file-saver";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import draggable from "vuedraggable";

export default {
  props: {
    documents: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      edit_filename_id: null,
      link_full_image: "",
      dialog: false,
      isMobile: false,
      isLoadingUpdateFileInfo: false,
      isLoading: false,
    };
  },
  computed: {
    // sortedDocuments: function() {
    //   function compare(a, b) {
    //     if (a.sort < b.sort) return 1;
    //     if (a.sort > b.sort) return -1;
    //     return 0;
    //   }
    //   return this.documents.sort(compare);
    // },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
  },
  methods: {
    truncateFileName(fileName, maxLength = 30) {
      if (!fileName) return '';
      // Преобразуем в строку на случай, если передано число (например, item.id)
      fileName = String(fileName);
      if (fileName.length <= maxLength) return fileName;
      
      // Находим расширение файла
      const lastDotIndex = fileName.lastIndexOf('.');
      if (lastDotIndex === -1) {
        // Нет расширения, просто обрезаем
        return fileName.substring(0, maxLength - 3) + '...';
      }
      
      const extension = fileName.substring(lastDotIndex);
      const nameWithoutExt = fileName.substring(0, lastDotIndex);
      const availableLength = maxLength - extension.length - 3; // -3 для "..."
      
      if (availableLength > 0) {
        return nameWithoutExt.substring(0, availableLength) + '...' + extension;
      } else {
        // Если даже с расширением слишком длинно
        return fileName.substring(0, maxLength - 3) + '...';
      }
    },
    updateFileInfo(item) {
      if (this.isStaff) {
        if (!item.original_name || item.original_name.trim() === "") {
          return;
        }
        this.isLoadingUpdateFileInfo = true;
        this.axios
          .patch(`/api/v1/cars_files/${item.id}`, {
            cars_files: {
              original_name: item.original_name.trim()
            }
          }, {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          })
          .then(() => {
            this.edit_filename_id = null;
          })
          .catch(error => {
            this.setError(error, this.$t('errors.error'));
          })
          .finally(() => (this.isLoadingUpdateFileInfo = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    moveDocument(e) {
      let document_id = this.documents[e.oldIndex].id;
      if (document_id === undefined) {
        return;
      }
      // sort documents
      this.documents.splice(e.newIndex, 0, this.documents.splice(e.oldIndex, 1)[0]);
      this.axios
        .patch(`api/v1/cars_files_sorting`,
          {
            cars_files: {
              id: document_id,
              new_position: e.newIndex + 1,
              old_position: e.oldIndex + 1,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        )
        // .then((response) => {
        //   console.log(response);
        //   // let new_positions = response.data;
        //   // this.documents = this.documents.map((document) => {
        //   //   let new_position = new_positions[document.id];
        //   //   document.sort = new_position.sort;
        //   //   return document;
        //   // });
        // })
        .catch((error) => this.setError(error, this.$t("errors.error")))
    },
    screenFullImage(item) {
      this.link_full_image = item.url;
      this.dialog = true;
    },
    downloadItem(item) {
      if (!this.isNative) {
        saveAs(`${item.url}`);
      } else {
        this.downloadFileToMobile(item.url);
      }
    },
    downloadFileToMobile(item_url) {
      if (Filesystem.checkPermissions()) {
        // Сначала получаем Blob из URL
        fetch(item_url)
          .then(response => response.blob())
          .then(blob => {
            // Теперь у нас есть настоящий Blob объект
            const getBase64FromBlob = async (blob) => {
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                }
              });
            }

            return getBase64FromBlob(blob);
          })
          .then((base64) => {
            // Определяем расширение файла
            let fileExtension = '';

            // Пытаемся получить расширение из URL
            const urlExtMatch = item_url.match(/\.([^./?#]+)($|\?|#)/);
            if (urlExtMatch) {
              fileExtension = `.${urlExtMatch[1].toLowerCase()}`;
            }
            // Если не удалось получить из URL, пытаемся определить из MIME-типа в base64
            else if (base64.startsWith('data:')) {
              const mimeMatch = base64.match(/^data:([^;]+);/);
              if (mimeMatch) {
                const mimeType = mimeMatch[1].toLowerCase();
                if (mimeType.startsWith('image/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                } else if (mimeType === 'application/pdf') {
                  fileExtension = '.pdf';
                } else if (mimeType.startsWith('video/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                } else if (mimeType.startsWith('audio/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                }
              }
            }

            // save file
            async function writeFile() {
              return await Filesystem.writeFile({
                path: `photo_${Date.now()}_${Math.floor(Math.random() * 1000)}${fileExtension}`,
                data: base64,
                directory: Directory.Documents,
              });
            }

            writeFile().then((getUriResult) => {
              // share file opened file
              let shareFile = async () => {
                await Share.share({
                  title: 'Download document',
                  files: [getUriResult.uri],
                }).catch((error) => {
                  console.log("shareFile", error)
                });
              };

              shareFile();
            }).catch((error) => {
              console.log("shareFile", error)
            });
          })
          .catch(error => {
            console.log("Error getting base64:", error);
          });
      } else {
        Filesystem.requestPermissions();
      }
    },
    deleteItem(item) {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t('custom.you_sure_title'),
          text: this.$t('custom.you_sure_text'),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t('custom.you_sure_yes'),
          cancelButtonText: this.$t('custom.you_sure_no'),
        }).then(result => {
          if (result) {
            this.axios
              .delete(`/api/v1/cars_files/${item.id}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken
                }
              })
              .then(response => {
                this.documents.splice(this.documents.indexOf(item), 1);
                this.$notify(this.$t('custom.deleted'), this.$t('other.delete_file'), "success", 2000);
              })
              .catch(error => this.setError(error, this.$t('errors.delete_file')));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sortUp(item) {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .get(`api/v1/cars_files/sort_up/${item.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          })
          .then(() => {
            item.sort += 1;
            let foundIndex = this.documents.findIndex(
              element => element.id === item.id
            );
            this.documents.splice(foundIndex, 1, item);
            this.$notify(this.$t('other.sort_files_title'), this.$t('other.sort_files_text'), "success");
          })
          .catch(error =>
            this.setError(error, this.$t('errors.sort_file'))
          )
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sortDown(item) {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .get(`api/v1/cars_files/sort_down/${item.id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          })
          .then(() => {
            item.sort -= 1;
            let foundIndex = this.documents.findIndex(
              element => element.id === item.id
            );
            this.documents.splice(foundIndex, 1, item);
            this.$notify(this.$t('other.sort_files_title'), this.$t('other.sort_files_text'), "success");
          })
          .catch(error =>
            this.setError(error, this.$t('errors.sort_file'))
          )
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    }
  },
  components: {
    MediaThumb,
    draggable
  }
};
</script>
